export default __webpack_public_path__ + "static/team-david@2x-df5a4a02a0cd9718a62fa046d3949b67.png";